export function isValidPhone(value) {
  var length = value.replace(/\D+/g, '').length;
  return length === 11;
}
export function isEmail(value) {
  // eslint-disable-next-line no-useless-escape
  return /^(([^<>()\[\].,;:\s@"]+(\.[^<>()\[\].,;:\s@"]+)*)|(".+"))@(([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{2,})$/i.test(value);
}
export function isValidId(value) {
  return /^\d+$/.test(value);
}
export function isValidLogin(login) {
  return /^\d+$/.test(login) || isEmail(login);
}
export function isValidCode(code) {
  return /^\d{4}$/.test(code);
}